'use strict';

var tealium = require('../tealium');

var checkout = {
    init: function() {
		$(document).ready(function(){
		var socialSignInCookie = MERCH_UTILS.getCookie("socialSignin");
		//var socialSignInCookie = getCookie("socialSignin");
		var analyticsData = window.utag_data;
		if(socialSignInCookie && analyticsData) {
			if(socialSignInCookie !== "Google" && socialSignInCookie !== "AppleWebSignIn") {
				var obj = {
		    		event_name : "social_sign_in",
					sign_in_mall : analyticsData.shopping_mall ,
					sign_in_brand : analyticsData.current_brand,
					sign_in_vendor : 'Facebook',
					fb_login_id : socialSignInCookie
  				}
				var currentStepObject = getCurrentStepObject();
				if (currentStepObject) {
					if (currentStepObject.page_name) {
						obj.page_name = currentStepObject.page_name;
					}
					if (currentStepObject.step_name) {
						obj.step_name = currentStepObject.step_name;
					}
					if (currentStepObject.skip_steps) {
						obj.skip_steps = currentStepObject.skip_steps;
					}
				}
				tealium.triggerEvent(obj);
			} else {
			if(socialSignInCookie === "AppleWebSignIn") socialSignInCookie = 'Apple';
				var obj = {
					event_name: "social_sign_in",
					sign_in_mall: analyticsData.shopping_mall,
					sign_in_brand: analyticsData.current_brand,
					sign_in_vendor: socialSignInCookie
				}
				var currentStepObject = getCurrentStepObject();
				if (currentStepObject) {
					if (currentStepObject.page_name) {
						obj.page_name = currentStepObject.page_name;
					}
					if (currentStepObject.step_name) {
						obj.step_name = currentStepObject.step_name;
					}
					if (currentStepObject.skip_steps) {
						obj.skip_steps = currentStepObject.skip_steps;
					}
				}
			tealium.triggerEvent(obj);
			}
			MERCH_UTILS.setCookie("socialSignin",false,-1);
		}
		});
 		$( document ).ajaxSuccess(function( event, xhr, settings ) {
  			if ( settings.url.indexOf(Urls.addCoupon) > -1  ) {
        		var vars = [], hash,couponResponse = '';
        		var couponCode = '';
        		var hashes = settings.url.split('?')[1].split('&');
        		for(var i = 0; i < hashes.length; i++)
        		{
         		 	hash = hashes[i].split('=');
          			vars.push(hash[0]);
          			vars[hash[0]] = hash[1];
        		}  			
    			var response = $.parseHTML(xhr.responseText);
    			if( vars.length != 0 && vars.couponCode != null ){
    				couponCode = vars.couponCode;
    			}
    			var code = $(response).find('.error-messages .error').data('code'); 
    			if( $(response).filter('.error-messages').find('.coupon-code-error').length > 0 ){
    				couponResponse = $(response).filter('.error-messages').find('.coupon-code-error').text().trim();
    			}
    			if(couponResponse == '' &&  $(response).filter('.error-messages').find('.applied-coupon-code').length > 0){
    				couponResponse = $(response).filter('.error-messages').find('.applied-coupon-code').text().trim();
    			}
    			var obj = {
		    		event_name : "coupon_code",
		    		coupon_code : couponCode,
		    		coupon_code_response : couponResponse
  				}
  				tealium.triggerEvent(obj);
  			}
  			if($('input[name="plccRebuttalVal"]').length > 0 && $('input[name="plccRebuttalVal"]').val() == 'true'){
				var obj = {
		    		event_name : "plc_offer_rebuttal",
					event_location_plc : ["plcc_offer_rebuttal"]
	        	}
	        	tealium.triggerEvent(obj);
				$('input[name="plccRebuttalVal"]').val("false");
	 		}
  			if ( settings.url.indexOf(Urls.applyGiftCard) > -1  ) {
  				var response = $.parseJSON(xhr.responseText).giftCertificate.success;
  				var giftCardResponse = '';
  				if( response == false ){
  					giftCardResponse = $.parseJSON(xhr.responseText).giftCertificate.responseMessage;
  				}
  				var obj = {
		    		event_name : "apply_gift_card",
		    		apply_gift_card_response : giftCardResponse
	        	}
  				tealium.triggerEvent(obj);
  			}
  			if ( settings.url.indexOf(Urls.redeemADSCert) > -1  ) {
  				var response = $.parseJSON(xhr.responseText).message;
  				var obj = {
		    		event_name : "reward_certificate",
		    		apply_reward_certificate_response : response
  				}
  				tealium.triggerEvent(obj);
  			}
		});

    	var plccZipCodeErrorObj={};
    	if(utag_data.plcc_payment_error) {
    		plccZipCodeErrorObj.event_name="plcc_payment_error";
    		plccZipCodeErrorObj.error_response = utag_data.plcc_payment_error;
    		tealium.triggerEvent(plccZipCodeErrorObj);
    	}
    	
    	
    }
};

exports.init = checkout.init;
